import {Component, Input, OnInit} from '@angular/core';
import {Activity, ActivityEvent, Label, Player, Project, Session, User} from '../../../../core/models';

@Component({
  selector: 'app-project-activity-detection-summary',
  templateUrl: './activity-detection-summary.html'
})
export class ActivityDetectionSummaryComponent implements OnInit {
  @Input() project: Project;
  @Input() activity: Activity;
  @Input() player: Player;
  confidence: string;
  operation: string;
  label: Label;
  reporter: User;
  session: Session;
  accusationType: string;
  evidenceSummary: string;

  constructor() {
  }

  ngOnInit() {
    if (this.activity.event == ActivityEvent.ACCUSATION) {
      this.operation = 'accused ';
      this.player = this.activity.player;
      this.confidence = this.activity.accusation.confidence;
      this.session = this.activity.accusation.session;
      this.reporter = this.activity.reporter;
      this.accusationType = this.activity.accusation.accusationType.name;
      this.evidenceSummary = this.activity.accusation.evidenceSummary;
      this.activity.link = ['/project', this.project.id, 'player', this.player.id, 'accusation', this.activity.accusation.id];
    } else if (this.activity.event == ActivityEvent.DETECTION) {
      this.operation = 'labeled ';
      this.label = this.activity.label;
      this.player = this.activity.player;
      this.reporter = this.activity.reporter;
      this.activity.link = ['/project', this.project.id, 'activity', 'detection', this.activity.detection.id];
    }
  }
}

